"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const atoms_1 = require("../../atoms");
const MIN_WIDTH_COEFFICIENT = 0.2; // 20vw;
const MIN_HEIGHT_COEFFICIENT = 0.1; // 10vw;
function StickyCardResizer({ size, visible, onResizeAction, diagonalResizing = false, }) {
    const windowSize = (0, ui_1.useScreenSize)();
    const onResizing = (newSize) => {
        onResizeAction(ui_1.ActionType.DRAG, newSize);
    };
    const onResizeEndHandler = (newSize) => {
        onResizeAction(ui_1.ActionType.MOUSE_UP, newSize);
    };
    const minimumSize = {
        width: windowSize.height * MIN_WIDTH_COEFFICIENT,
        height: windowSize.height * MIN_HEIGHT_COEFFICIENT,
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(TopRightCorner, { direction: diagonalResizing ? atoms_1.ResizeDirection.Diagonal : atoms_1.ResizeDirection.Width, currentSize: size, minimumSize: minimumSize, "$visible": visible, onResizing: onResizing, onResizeEnd: onResizeEndHandler, "data-e2e": 'StickyCardResizer_TopRightCorner' }), (0, jsx_runtime_1.jsx)(BottomRightCorner, { direction: diagonalResizing ? atoms_1.ResizeDirection.Diagonal : atoms_1.ResizeDirection.All, currentSize: size, minimumSize: minimumSize, "$visible": visible, onResizing: onResizing, onResizeEnd: onResizeEndHandler, "data-e2e": 'StickyCardResizer_BottomRightCorner' }), (0, jsx_runtime_1.jsx)(BottomLeftCorner, { direction: diagonalResizing ? atoms_1.ResizeDirection.Diagonal : atoms_1.ResizeDirection.Height, currentSize: size, minimumSize: minimumSize, "$visible": visible, onResizing: onResizing, onResizeEnd: onResizeEndHandler, "data-e2e": 'StickyCardResizer_BottomLeftCorner' })] }));
}
exports.default = StickyCardResizer;
const DraggedCorner = (0, styled_components_1.default)(atoms_1.StickyResizeCorner) `
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};

  transition: opacity 0.2s;

  pointer-events: ${({ $visible }) => ($visible ? 'all' : 'none')};
`;
const TopRightCorner = (0, styled_components_1.default)(DraggedCorner) `
  top: -10px;
  right: -10px;

  cursor: ew-resize;
`;
const BottomRightCorner = (0, styled_components_1.default)(DraggedCorner) `
  right: -10px;
  bottom: -10px;

  cursor: nwse-resize;
`;
const BottomLeftCorner = (0, styled_components_1.default)(DraggedCorner) `
  bottom: -10px;
  left: -10px;

  cursor: ns-resize;
`;
